module.exports = __webpack_public_path__ + "static/media/icons-solid-check-gray.3b14a50b.svg";